//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const energyLevel = useStore((state) => state.energyLevel);
  const setEnergyLevel = useStore((state) => state.setEnergyLevel);
  const { onNext, currentIndex, onPrev } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.energyLevel.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={energyLevel}
          onChange={(value) => {
            setEnergyLevel(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'energy-level',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Zesty! I'm almost always energetic"}>
            {t('onboarding.energyLevel.options.energetic')}
          </Option>
          <Option value={'Inconsistent: Sometimes I have slumps'}>
            {t('onboarding.energyLevel.options.inconsistent')}
          </Option>
          <Option value={'What energy? I feel like a wet blanket'}>
            {t('onboarding.energyLevel.options.wetBlanket')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
